import { createReducer } from '@reduxjs/toolkit'
import { types } from '../../actions/campaigns/summary_actions'

export default createReducer({}, (builder) => {
  builder
    .addCase(types.SET_HIDDEN_FIELDS, (state, action) => {
      if (!state.hiddenFields) {
        state.hiddenFields = []
      }
      
      const index = state.hiddenFields.findIndex(el => el.elementId === action.hiddenFields.elementId)

      if (index !== -1) {
        state.hiddenFields[index].totalPrints = action.hiddenFields.totalPrints
      } else {
        state.hiddenFields.push({
          elementId: action.hiddenFields.elementId,
          totalPrints: action.hiddenFields.totalPrints
        })
      }
    })
})
